
import { ChangeDetectorRef, Component, EventEmitter, OnInit, Pipe, PipeTransform } from '@angular/core';
import { FormBuilder, FormGroup, Validators,FormArray  } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ModalController, ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { forkJoin, iif } from 'rxjs';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYearRanges} from 'src/app/shared/commen-function-file';
import { LndSuccessMsgComponent } from '../lnd-success-msg/lnd-success-msg.component';


@Component({
  selector: 'app-add-faculty-popup',
  templateUrl: './add-faculty-popup.component.html',
  styleUrls: ['./add-faculty-popup.component.scss'],
})
export class AddFacultyPopupComponent  implements OnInit {
  addFacultyForm!: FormGroup;
  buttonColorName: any;
 buttonColorCode: any = 'gray'
 loggedInCompanyMDCode: any | null;
 loggedInUserRole: any;
 loggedInUserRoles: any;
 loggedInCompanyReviewCycle: any | null;
 loggedInUserRoleIsEmployee: any;
 pmsYears: any = [];
 fromYear: any;
 selectedYear: any;
 toYear: any;
 selectedYearForCompetency: any = null;
 loggedInCompanyFiscalyear: any;
 loggedInUserCompanyID: any;
 subModuleButtonColor: any | null;
 loggedInUserEmpCode: any | null;
 loggedInUserId: any | null;

  constructor(
    private datePipe: DatePipe, public sharedService: SharedService,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute, private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,private modalController: ModalController,
    private PdfDownload: PdfDownloadService, private dataRefreshService: DataRefreshService, public dialogRef: MatDialogRef<AddFacultyPopupComponent>
  ){
    
  }

  createFacultyGroup(): FormGroup {
    return this.fb.group({
      facultyName: ['', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
      contactNumber: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      email: ['', [Validators.required, Validators.email]],
      details: ['', [Validators.required, Validators.maxLength(255)]],
      link: ['', [Validators.required, Validators.pattern(/^(https?:\/\/)?([\w\d\-]+\.){1,}[\w]{2,}(\/.+)?$/)]]
    });
  }
  

  
  get faculties(): FormArray {
    return this.addFacultyForm.get('faculties') as FormArray;
  }
  

  //  ========================================== For errror validation ==================================================

  hasError(controlName: string, errorName: string): boolean {
    return this.addFacultyForm.get(controlName)?.hasError(errorName) ?? false;
  }
  
 
  ngOnInit(): void {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
      this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
      this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID'))); 
      this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
      this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
      if (this.loggedInCompanyFiscalyear) {
        this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
      }
      this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
      this.loggedInUserId = sessionStorage.getItem('loggedInUserName');
      this.loggedInUserId = sessionStorage.getItem('loggedInUserRole');
      this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
      if (this.loggedInUserRole) {
        this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
      }
      this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
      this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
      if (this.loggedInUserRoles.length == 1) {
        for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
          if (this.loggedInUserRoles[i].displayName == "Employee") {
            this.loggedInUserRoleIsEmployee = true
          }
        }
      }
    this.addFacultyForm = this.fb.group({
     faculties: this.fb.array([this.createFacultyGroup()])
});
      this. getpmsyearlist();
    }
  



  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);
      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;     
      this.setSelectedYear(yearValue);
    });
  }
  
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
    if (selectedYearObj) {
          this.selectedYearForCompetency = selectedYearObj?.year;       
          let test = selectedYearObj?.year.split('-');
          this.fromYear = test[0];
          this.toYear = test[1];
          // this.defaultCallFunctionsList();
          [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }



  getYearSetupForReimbursement(year: any) {
    this.selectedYearForCompetency = year;
    this.selectedYear = year;
  
  }
  


  openDialog(message: string, buttonText: string = 'OK', buttonColor: string = 'red', showSuccessIcon: boolean = false, showSuccessMessage: boolean = false, showCloseIcon: boolean = false) {
    return this.dialog.open(ConfirmationPopupComponent, {
      disableClose: false,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: buttonText,
        btn2BgColor: buttonColor,
        showSuccessIcon: showSuccessIcon,
        showSuccessMessage: showSuccessMessage,
        showCloseIcon: showCloseIcon
      }
    });
  }



  
  //  =========================================== For add more faculty button ===================================================

  addFacultyGroup(): void {
    this.faculties.push(this.createFacultyGroup());
  }



  // ==========================================  For remove faulty card ===============================================================

  removeFacultyGroup(index: number): void {
    this.faculties.removeAt(index);
  }
  


  // ===================================================  Submit Faculty Form ==========================================================

  submitFaculty() {
    if (this.addFacultyForm.valid) {
      sessionStorage.setItem('addedFaculties', JSON.stringify(this.addFacultyForm.value.faculties));
      this.toastr.success('Faculty added successfully!');
      this.dialogRef.close(); 
    } else {
      this.toastr.error('Please fill all required fields correctly.');
    }
  }
  


  //  ============================================== Close the dialogue ===========================================================

  closeDialog() {
    this.dialogRef.close();
  }
  }
